module.exports = __webpack_public_path__ + "img/img20.945ae2fa.png";